import WebApp from "@twa-dev/sdk";
import type { WebApp as WebAppType } from "@twa-dev/types";

/**
 * Returns the Telegram WebApp SDK or `null` when not running inside a real
 * Telegram client. The SDK polyfill is always defined — even in a desktop
 * browser preview — so we detect a real client by the presence of a
 * non-empty `initData` payload, which only Telegram itself can mint.
 *
 * Effect-based hooks call this on each render's effect so a mid-session
 * SDK swap (HMR with a different stub) is picked up. Memoised hooks
 * (`useInitData`, `useHaptics`) resolve only once on mount, which is fine
 * because their data does not change within a Telegram session.
 */
export function getWebApp(): WebAppType | null {
  const sdk = WebApp as WebAppType | undefined;
  if (!sdk) return null;
  if (typeof sdk.initData !== "string" || sdk.initData.length === 0) return null;
  return sdk;
}
